import { gsap } from "gsap";

const circle = document.querySelector(".inner-circle");
const hpGrid = document.querySelector(".hp-grid");
const hpGridItems = document.querySelectorAll(".hp-grid-item");

if (hpGridItems && hpGrid && circle) {
  let activeItem = null;
  let bgTimeout = null;

  /**
   * Utility: measure height safely (Safari-proof)
   */
  function measureHeight(el) {
    el.style.height = "auto";
    el.style.visibility = "hidden";
    el.style.position = "absolute";

    document.body.appendChild(el);
    const h = el.offsetHeight;
    document.body.removeChild(el);

    el.style.height = "";
    el.style.visibility = "";
    el.style.position = "";

    return h;
  }

  /**
   * Activate item
   */
  function activateItem(item) {
    if (activeItem === item) return;
    activeItem = item;

    const img = item.querySelector("img");
    const itemCircle = item.querySelector(".circle");
    const itemBg = item.querySelector(".item-bg");

    const content = item.querySelector(".content-wrap");
    const detailsWrap = item.querySelector(".details-wrap");
    const details = item.querySelector(".details");

    // reset others
    deactivateAll(item);

    // swap center image
    if (img) {
      gsap.to(itemCircle, {
        scale: 0.1,
        duration: 0.4,
        ease: "power2.out",
        onComplete: () => {
          circle.style.backgroundImage = `url(${img.src})`;
        },
      });
    }

    // measure details height SAFELY
    const clone = details.cloneNode(true);
    clone.style.opacity = "1";
    clone.style.position = "static";
    clone.style.pointerEvents = "none";
    const DETAILS_TOP_OFFSET = 32; // top-4 = 1rem = 16px
    const SAFARI_BUFFER = 12; // prevents under-shift

    const detailsHeight =
      measureHeight(clone) + DETAILS_TOP_OFFSET + SAFARI_BUFFER;

    // prepare
    gsap.set(detailsWrap, {
      height: 0,
    });
    gsap.set(details, {
      opacity: 0,
    });

    // animate layout (NO transforms on flex children)
    gsap
      .timeline()
      .to(content, {
        marginTop: -detailsHeight,
        duration: 0.45,
        ease: "power2.inOut",
      })
      .to(
        detailsWrap,
        {
          height: detailsHeight,
          duration: 0.45,
          ease: "power2.inOut",
        },
        "<"
      )
      .to(
        details,
        {
          opacity: 1,
          duration: 0.25,
          ease: "power1.out",
        },
        "-=0.15"
      );

    clearTimeout(bgTimeout);
    bgTimeout = setTimeout(() => {
      gsap.to(itemBg, {
        opacity: 1,
        duration: 0.25,
      });
    }, 300);

    item.classList.add("active");
  }

  /**
   * Deactivate all items
   */
  function deactivateAll(except = null) {
    clearTimeout(bgTimeout);
    circle.style.backgroundImage = "";

    hpGridItems.forEach((item) => {
      if (item === except) return;

      const content = item.querySelector(".content-wrap");
      const detailsWrap = item.querySelector(".details-wrap");
      const details = item.querySelector(".details");
      const itemCircle = item.querySelector(".circle");
      const itemBg = item.querySelector(".item-bg");

      item.classList.remove("active");

      gsap.killTweensOf([content, detailsWrap, details, itemCircle, itemBg]);

      gsap.to(itemBg, {
        opacity: 0,
        duration: 0.2,
      });

      gsap.to(itemCircle, {
        scale: 1,
        duration: 0.25,
        ease: "power2.out",
      });

      gsap.to(details, {
        opacity: 0,
        duration: 0.2,
      });

      gsap.to(detailsWrap, {
        height: 0,
        duration: 0.35,
        ease: "power2.inOut",
      });

      gsap.to(content, {
        marginTop: 0,
        duration: 0.35,
        ease: "power2.inOut",
      });
    });
  }

  /**
   * Desktop interactions
   */
  hpGridItems.forEach((item) => {
    item.addEventListener("mouseenter", () => activateItem(item));
    item.addEventListener("mouseleave", () => deactivateAll());
  });

  hpGrid.addEventListener("mouseleave", () => deactivateAll());
}
